<template>
    <div class="panel modalDetailsPanel">
        <ol class="panelDetails">
            <li>
                <span>Naam</span>
                <span>{{ consortium.name }}</span>
            </li>
            <li>
                <span>Penvoerder</span>
                <span>
                    {{ consortium.Contact.contactOrganisationName }}<br />
                    <a :href="`mailto:${consortium.Contact.email}`">{{ consortium.Contact.email }}</a><br />
                    {{ consortium.Contact.phone }}<br />
                </span>
            </li>
            <li>
                <span>Organisaties</span>
                <span>
                    <template v-for="organisation in consortium.Organisations">
                        <i class="fa-solid fa-building"></i> {{ organisation.name}}<br />
                    </template>
                </span>
            </li>
            
        </ol>
    </div>
</template>

<script>

export default {
    props: {
        consortium: {
            type: Object,
            required: true
        }
    }
}
</script>